"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Card_1 = require("../models/Card");
var ApiService_1 = require("../services/ApiService");
var Character_1 = require("../models/Character");
var beastTyrantData = require("../data/beast_tyrant.json");
var berserkerData = require("../data/berserker.json");
var bruteData = require("../data/brute.json");
var cragheartData = require("../data/cragheart.json");
var doomstalkerData = require("../data/doomstalker.json");
var elementalistData = require("../data/elementalist.json");
var mindthiefData = require("../data/mindthief.json");
var nightshroudData = require("../data/nightshroud.json");
var plagueheraldData = require("../data/plagueherald.json");
var quartermasterData = require("../data/quartermaster.json");
var sawbonesData = require("../data/sawbones.json");
var scoundrelData = require("../data/scoundrel.json");
var soothsingerData = require("../data/soothsinger.json");
var spellweaverData = require("../data/spellweaver.json");
var summonerData = require("../data/summoner.json");
var sunkeeperData = require("../data/sunkeeper.json");
var tinkererData = require("../data/tinkerer.json");
var CharacterDataStore = /** @class */ (function () {
    function CharacterDataStore(localStoreService) {
        var _this = this;
        this.characters = [];
        this.finished = false;
        this.notStartedLoading = true;
        this.loadCharacterData = function () {
            if (_this.notStartedLoading) {
                _this.notStartedLoading = false;
                _this.setCharacter(_this.transformToCharacter(beastTyrantData));
                _this.setCharacter(_this.transformToCharacter(berserkerData));
                _this.setCharacter(_this.transformToCharacter(bruteData));
                _this.setCharacter(_this.transformToCharacter(cragheartData));
                _this.setCharacter(_this.transformToCharacter(doomstalkerData));
                _this.setCharacter(_this.transformToCharacter(elementalistData));
                _this.setCharacter(_this.transformToCharacter(mindthiefData));
                _this.setCharacter(_this.transformToCharacter(nightshroudData));
                _this.setCharacter(_this.transformToCharacter(plagueheraldData));
                _this.setCharacter(_this.transformToCharacter(quartermasterData));
                _this.setCharacter(_this.transformToCharacter(sawbonesData));
                _this.setCharacter(_this.transformToCharacter(scoundrelData));
                _this.setCharacter(_this.transformToCharacter(soothsingerData));
                _this.setCharacter(_this.transformToCharacter(spellweaverData));
                _this.setCharacter(_this.transformToCharacter(summonerData));
                _this.setCharacter(_this.transformToCharacter(sunkeeperData));
                _this.setCharacter(_this.transformToCharacter(tinkererData));
            }
        };
        this.transformToCharacter = function (rawJsonData) {
            var cards = [];
            var type = rawJsonData.type;
            var icon = rawJsonData.icon;
            rawJsonData.cards.forEach(function (item) {
                var cardName = item.name;
                var card = new Card_1.Card(type, cardName, item.level, _this.localStoreService.getCardInPlayerDeckState(type, cardName), _this.localStoreService.getCardInScenarioDeckState(type, cardName));
                cards.push(card);
            });
            return new Character_1.Character(type, cards, _this.localStoreService.getCharacterLevel(type), icon, rawJsonData.numOfCards);
        };
        this.isCharacterLoaded = function (type) {
            return _this.characters.filter(function (char) { return char.type === type; }).length === 1;
        };
        this.inLevelRange = function (card) {
            if (card.level === "X" || card.level === "M") {
                return true;
            }
            return Number(card.level) <= _this.level;
        };
        this.maxCardsHaveBeenSelected = function (card) {
            return !card.inScenarioDeck && _this.currentCards.filter(function (card) { return card.inScenarioDeck; }).length >= _this.currentCharacter.numOfCards;
        };
        this.capitalize = function (word) {
            return word[0].toUpperCase() + word.slice(1);
        };
        this.localStoreService = localStoreService;
        this.selectedCharacter = this.localStoreService.getSelectedCharacter();
    }
    Object.defineProperty(CharacterDataStore.prototype, "currentCharacter", {
        get: function () {
            var _this = this;
            if (this.isCharacterLoaded(this.selectedCharacter)) {
                return this.characters.filter(function (char) { return char.type === _this.selectedCharacter; })[0];
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CharacterDataStore.prototype, "level", {
        get: function () {
            return this.currentCharacter != null ? this.currentCharacter.level : 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CharacterDataStore.prototype, "availableCards", {
        get: function () {
            return this.currentCards.filter(this.inLevelRange);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CharacterDataStore.prototype, "selectedCards", {
        get: function () {
            return this.currentCards.filter(function (val) { return val.inScenarioDeck; }).filter(this.inLevelRange);
        },
        enumerable: true,
        configurable: true
    });
    CharacterDataStore.prototype.setSelectedCharacter = function (characterType) {
        this.selectedCharacter = characterType;
        this.localStoreService.setSelectedCharacter(this.selectedCharacter);
        if (!this.isCharacterLoaded(characterType)) {
            this.finished = false;
            this.notStartedLoading = true;
            this.loadCharacterData();
        }
    };
    CharacterDataStore.prototype.toggleToFromScenarioDeck = function (card) {
        if (card.inPlayerDeck && card.imgUrl != ApiService_1.ApiService.defaultCardUrl(this.selectedCharacter)) {
            if (this.maxCardsHaveBeenSelected(card)) {
                alert("You have selected maximum amount of cards for your character.\n\n\n                        " + this.capitalize(this.selectedCharacter) + " can hold " + this.currentCharacter.numOfCards + " cards.");
                return;
            }
            card.inScenarioDeck = !card.inScenarioDeck;
            this.localStoreService.setCardInScenarioDeckState(this.selectedCharacter, card);
        }
    };
    CharacterDataStore.prototype.toggleToFromPlayerDeck = function (currentCard) {
        var isAddingCard = !currentCard.inPlayerDeck;
        var playerCardCount = this.currentCards.filter(function (card) { return card.inPlayerDeck; }).length;
        var levelOneCards = this.currentCards.filter(function (card) { return Card_1.Card.alwaysInPlayerDeck(card); }).length;
        var currentLevel = this.currentCharacter.level;
        var allowedCardAmount = levelOneCards + (currentLevel - 1);
        var numberOfLastLevelCardsSelected = this.countCardsInPlayerDeck(currentLevel);
        var numberOfPreviousLevelCardsSelected = this.countCardsInPlayerDeck(currentLevel - 1);
        if (isAddingCard && playerCardCount === allowedCardAmount) {
            alert("You have selected all card allowed. Remove a card from your player deck first.");
            return;
        }
        if (isAddingCard && Number(currentCard.level) === currentLevel && (numberOfLastLevelCardsSelected === 1 || numberOfPreviousLevelCardsSelected === 2)) {
            alert("Cannot select two cards of current level nor card from current level when two previous level cards are selected.");
            return;
        }
        if (isAddingCard && Number(currentCard.level) === currentLevel - 1 && numberOfLastLevelCardsSelected === 1 && numberOfPreviousLevelCardsSelected === 1) {
            alert("Cannot select two cards of previous level when one card is selected from last level.");
            return;
        }
        currentCard.inPlayerDeck = !currentCard.inPlayerDeck;
        currentCard.inScenarioDeck = false;
        this.localStoreService.setCardInPlayerDeckState(this.selectedCharacter, currentCard);
        this.localStoreService.setCardInScenarioDeckState(this.selectedCharacter, currentCard);
    };
    CharacterDataStore.prototype.changeLevel = function (event) {
        // @ts-ignore
        this.currentCharacter.level = Number(event.target.value);
        this.localStoreService.setCharacterLevel(this.selectedCharacter, this.currentCharacter.level);
    };
    CharacterDataStore.prototype.setCharacter = function (character) {
        if (!this.isCharacterLoaded(character.type)) {
            this.characters.push(character);
            this.finished = true;
        }
    };
    Object.defineProperty(CharacterDataStore.prototype, "currentCards", {
        get: function () {
            var _this = this;
            var characters = this.characters.filter(function (char) { return char.type === _this.selectedCharacter; });
            return characters.length !== 1 ? [] : characters.values().next().value.allCards;
        },
        enumerable: true,
        configurable: true
    });
    CharacterDataStore.prototype.countCardsInPlayerDeck = function (level) {
        return this.currentCards.filter(function (card) { return Number(card.level) === level && card.inPlayerDeck; }).length;
    };
    __decorate([
        mobx_1.observable
    ], CharacterDataStore.prototype, "selectedCharacter", void 0);
    __decorate([
        mobx_1.observable
    ], CharacterDataStore.prototype, "characters", void 0);
    __decorate([
        mobx_1.observable
    ], CharacterDataStore.prototype, "finished", void 0);
    __decorate([
        mobx_1.computed
    ], CharacterDataStore.prototype, "currentCharacter", null);
    __decorate([
        mobx_1.computed
    ], CharacterDataStore.prototype, "level", null);
    __decorate([
        mobx_1.computed
    ], CharacterDataStore.prototype, "availableCards", null);
    __decorate([
        mobx_1.computed
    ], CharacterDataStore.prototype, "selectedCards", null);
    __decorate([
        mobx_1.action.bound
    ], CharacterDataStore.prototype, "setSelectedCharacter", null);
    __decorate([
        mobx_1.action.bound
    ], CharacterDataStore.prototype, "toggleToFromScenarioDeck", null);
    __decorate([
        mobx_1.action.bound
    ], CharacterDataStore.prototype, "toggleToFromPlayerDeck", null);
    __decorate([
        mobx_1.action.bound
    ], CharacterDataStore.prototype, "changeLevel", null);
    __decorate([
        mobx_1.action.bound
    ], CharacterDataStore.prototype, "setCharacter", null);
    return CharacterDataStore;
}());
exports.CharacterDataStore = CharacterDataStore;



//////////////////
// WEBPACK FOOTER
// ./src/stores/CharacterDataStore.ts
// module id = 761
// module chunks = 0